<script lang="ts">
    import { onMount } from "svelte";
    import ShopIntegrationService from "../../lib/ShopIntegrationService";
    import { FLOATING_BUTTON_DESCRIPTION_DELAY, FLOATING_BUTTON_LOCAL_STORAGE_KEY } from "../../config";
    import { trackFloatingActionButtonClick, trackBannerClick } from "../../stores/interactionTracking.svelte";

    let { href } = $props();
    const COLOR_PURPLE_140 = "var(--oc-base-color-purple-140, #522eb7)";
    let showDescription = $state(false);
    const wasClosed = localStorage?.getItem(FLOATING_BUTTON_LOCAL_STORAGE_KEY);
    let descriptionCanBeShown = ShopIntegrationService.getPageCluster() === "Storefront" && !wasClosed;

    function closeTooltip() {
        showDescription = false;
        localStorage?.setItem(FLOATING_BUTTON_LOCAL_STORAGE_KEY, "true");
    }

    onMount(() => {
        if (descriptionCanBeShown) {
            setTimeout(() => {
                showDescription = true;
            }, FLOATING_BUTTON_DESCRIPTION_DELAY);
        }
    });
</script>

<div class="floating-action-button-container" class:floating-tooltip={showDescription}>
    <div class="floating-action-button-wrapper">
        {#if showDescription}
            <div class="floating-action-button-description">
                <p class="oc-headline-50">NEU! Unser OTTO KI Assistent!</p>
                <p class="oc-copy-100">Erhalte persönliche Beratung und finde ganz einfach die Produkte, die zu dir passen.</p>
                <oc-link-v2
                    as-button
                    variant="underlined"
                    onclick={() => {
                        if (href) {
                            trackBannerClick();
                            window.location.href = href;
                        }
                    }}
                >
                    Starte jetzt deinen Dialog
                </oc-link-v2>
            </div>
        {/if}
        <div class="floating-action-button-buttons">
            {#if showDescription}
                <oc-icon-button-v2 variant="transparent" icon-color="#fff" icon="close" oc-aria-label="Chat Hinweis schließen" onclick={() => closeTooltip()}></oc-icon-button-v2>
            {/if}

            <oc-icon-button-v2
                class="floating-action-button"
                class:in-description={showDescription}
                icon={"speech-bubble-sparkles" as any}
                icon-color={showDescription ? COLOR_PURPLE_140 : "white"}
                size={"100"}
                elevation={showDescription ? undefined : "200"}
                oc-aria-label="OTTO KI Assistent"
                onclick={() => {
                    if (href) {
                        trackFloatingActionButtonClick();
                        window.location.href = href;
                    }
                }}
                data-testid="floating-action-button"
            ></oc-icon-button-v2>
        </div>
    </div>
</div>

<style lang="scss">
    @use "@otto-ec/design-tokens/tokens";
    @use "@otto-ec/otto-components-utils/scss/_mixins/breakpoint";

    .floating-action-button-container {
        width: 100%;
        max-width: 1152px;
        display: flex;
        justify-content: end;
        position: fixed;
        bottom: 0;
        pointer-events: none;
        margin-bottom: 20px;
        gap: tokens.$oc-semantic-spacing-100;
        z-index: 101;
        @media (min-width: 77em) {
            width: 84%;
        }

        &.floating-tooltip {
            margin-bottom: tokens.$oc-semantic-spacing-25;

            .floating-action-button-wrapper {
                filter: tokens.$oc-semantic-shadow-sticky;
            }

            .floating-action-button {
                --oc-semantic-color-canvas-background: unset;
                --oc-component-icon-button-default-background-color-hover: unset;
            }

            .floating-action-button-wrapper {
                padding: tokens.$oc-semantic-spacing-100 tokens.$oc-semantic-spacing-50 tokens.$oc-semantic-spacing-100 tokens.$oc-semantic-spacing-100;
                border-radius: tokens.$oc-semantic-border-radius-100;
                display: flex;
                gap: tokens.$oc-semantic-spacing-100;
                flex-direction: row;
                max-width: 305px;
                background-color: tokens.$oc-base-color-purple-140;
                margin-right: tokens.$oc-semantic-spacing-50;
            }
        }
    }

    .floating-action-button-wrapper {
        pointer-events: all;
        margin-right: tokens.$oc-semantic-spacing-100;
        --oc-semantic-color-text-default: tokens.$oc-base-color-white;
    }

    .floating-action-button-buttons {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: end;
        gap: tokens.$oc-semantic-spacing-50;
    }

    .floating-action-button-description {
        color: tokens.$oc-base-color-white;
        display: flex;
        flex-direction: column;
        text-align: right;
    }

    .floating-action-button {
        --oc-semantic-color-canvas-background: #{tokens.$oc-base-color-purple-140};
        --oc-component-icon-button-default-background-color-hover: #7e63ca;
    }
</style>
